import { memo } from 'react';
import { SliderDot, SliderFooterContainer } from './styled';

interface SliderFooterProps {
  current: number;
  total: number;
  onClick: (val: any) => void;
}

function SliderFooter({ current, total, onClick }: SliderFooterProps) {
  return (
    <SliderFooterContainer>
      {Array.from(Array(total).keys()).map((__dat, index) => (
        <SliderDot
          active={index === current}
          onClick={() => onClick(index)}
        />
      ))}
    </SliderFooterContainer>
  );
}

export default memo(SliderFooter);
